export enum QueryKeys {
  OVERVIEW = 'overview',
  COMPANY_INFO = 'companyInfo',
  PORTFOLIO = 'portfolio',
  ACCOUNTS = 'accounts',
  INBOX_MESSAGES = 'inboxMessages',
  SENT_MESSAGES = 'sentMessages',
  UNREAD_MESSAGE_COUNT = 'unreadMessageCount',
  LOAN_DETAIL = 'loanDetail',
  TRUST_ACCOUNT = 'trustAccount',
  VERIFY_RESET_PASSWORD = 'verifyResetPassword',
  ACCOUNT = 'account',
  HISTORY_ALL = 'allHistoryGrouped',
  HISTORY = 'history',
  HISTORY_LOAN_ACCOUNTS = 'historyLoanAccounts',
  DOCUMENTS = 'documents',
  RECENT_DOCUMENTS = 'recentDocuments',
  RECENT_DOCUMENTS_COUNT = 'recentDocumentsCount',
  DOCUMENT_YEARS = 'documentYears',
  DOCUMENT_DOWNLOAD = 'DOCUMENT_DOWNLOAD',
  UPCOMING_PAYMENTS = 'upcomingPayments',
  LAST_PAYMENT_BY_ACCOUNT = 'LAST_PAYMENT_BY_ACCOUNT',
  RECENT_PAYMENTS_FOR_ACCOUNTS = 'RECENT_PAYMENTS_FOR_ACCOUNTS',
  CONVENTIONAL_PAYMENT_DETAILS = 'conventionalPaymentDetails',
  BILLABLE_PAYMENT_DETAILS = 'billablePaymentDetails',
  ARM_PAYMENT_DETAILS = 'armPaymentDetails',
  LOC_PAYMENT_DETAILS = 'locPaymentDetails',
  SAVED_PAYMENTS = 'savedPayments',
  LAST_PAYMENT_INFO = 'LAST_PAYMENT_INFO',
  GET_CONVENIENCE_FEE = 'convenienceFee',
  COMPANY_PAYMENT_PROCESSING_FEES = 'companyPaymentProcessingFees',
  CONSTRUCTION_DRAW_REQUEST_FEATURE_ENABLED = 'constructionDrawRequestFeatureEnabled',
  CONSTRUCTION_REQUEST_DRAW_BUTTON_ENABLED = 'constructionRequestDrawButtonEnabled',
  DRAW_REQUESTS = 'drawRequests',
  DRAW_REQUEST_DETAILS = 'drawRequestDetails',
  DRAW_REQUEST_STATUS = 'drawRequestStatus',
  LOAN_PROGRESS = 'loanProgress',
  BUDGET_ITEMS = 'budgetItems',
  ATTACHMENTS = 'attachments',
  DRAW_REQUEST_MESSAGES = 'drawRequestMessages',
  DRAW_REQUEST_UNREAD_COUNT = 'drawRequestUnreadCount',
  CUSTOM_PORTAL_BANNER = 'customPortalBanner',
  PORTAL_ANNOUNCEMENT = 'portalAnnouncement',
  ANNOUNCEMENT_STATUS = 'announcementStatus',
  COMPANY_THEME = 'companyTheme',
  CHANGE_REQUESTS = 'changeRequests',
}
